import { useState, useContext, useEffect } from "react";
import { Box, Button, Grid, Stack } from "@mui/material";
//Srcs
import "../../Style/pagestyle.scss";

import { AuthContext } from "../../Context/AuthContext";
import { PageHeaderTitle } from "../../Utils/Component";
import InfoIcon from "@mui/icons-material/Info";
import SchoolIcon from "@mui/icons-material/School";
import TabInfomation from "./Tab/TabInfomation";
import TabEducationLevel from "./Tab/TabEducationLevel";
import { useGetMemberById } from "../../Hooks/useGetMemberById";

const getTabClass = (currentTab, tab) => {
  if (tab === currentTab) return "btn-tab-active";
  return "btn-tab";
};

export default function MemberDetails() {
  const { t } = useContext(AuthContext);

  const [tab, setTab] = useState("Infomation");
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  const { data, refetch } = useGetMemberById({ id });

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/member-in-mandate"}
        pageTitle={t("page_provincial_council_member")}
        detailTitle={data?.lastNameKh + " " + data?.firstNameKh}
      />

      <Grid container sx={{ marginTop: 2 }}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box
            sx={{
              my: 2,
              minWidth: 600,
              borderBottom: 2,
              borderColor: "divider",
            }}
          >
            <Stack direction="row" alignItems="center" sx={{ mb: "-2px" }}>
              <Button
                startIcon={<InfoIcon />}
                onClick={() => setTab("Infomation")}
                className={getTabClass("Infomation", tab)}
              >
                {t("thead_information")}
              </Button>

              <Button
                onClick={() => setTab("Education")}
                className={getTabClass("Education", tab)}
                startIcon={<SchoolIcon />}
              >
                {t("thead_education")}
              </Button>
            </Stack>
          </Box>
        </Grid>

        {["Infomation"].includes(tab) && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TabInfomation />
          </Grid>
        )}
 
        {["Education"].includes(tab) && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TabEducationLevel />
          </Grid>
        )}
      </Grid>
    </div>
  );
}
